module.exports = __webpack_public_path__ + "static/media/logo_crm.f93df2e4.png";